import { Box, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import React from 'react';
export const LegalDisclaimer = () => {
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, t('domain_search_suite.insight_widget.ai_disclaimer')));
};
//# sourceMappingURL=LegalDisclaimer.js.map